/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicMyHomeV1GetThinClientInfoModel,
  IMappers,
  TPublicMyHomeV1GetThinClientInfoResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetThinClientInfoResponse } from '../../../entities/thin_client_info/GetThinClientInfoResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPublicMyHomeV1GetThinClientInfoModel(): TPublicMyHomeV1GetThinClientInfoModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'price-estimator',
    pathApi: '/my-home/v1/get-thin-client-info/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IPublicMyHomeV1GetThinClientInfoOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchPublicMyHomeV1GetThinClientInfo<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IPublicMyHomeV1GetThinClientInfoOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPublicMyHomeV1GetThinClientInfoResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicMyHomeV1GetThinClientInfoModel(),
    config,
  )) as FetchResponse<TPublicMyHomeV1GetThinClientInfoResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetThinClientInfoResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPublicMyHomeV1GetThinClientInfoResponse>;
}
